var dateFormatter = new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
});
var dateTimeFormatter = new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    month: "2-digit",
    year: "numeric",
});
export var consultationStatusLabels = {
    active: "Ativa",
    canceled: "Cancelada",
    closed: "Fechada",
    finished: "Encerrada",
    planned: "Planejada",
    published: "Publicada",
};
export var formatDate = function (value) {
    if (!value) {
        return "-";
    }
    return dateFormatter.format(new Date(value));
};
export var formatDateTime = function (value) {
    if (!value) {
        return "-";
    }
    return dateTimeFormatter.format(new Date(value));
};
export var formatConsultationPeriod = function (startDate, endDate) { return "".concat(formatDate(startDate), " a ").concat(formatDate(endDate)); };
export var capitalizeSentence = function (value) {
    if (!value) {
        return "";
    }
    return value.charAt(0).toUpperCase() + value.slice(1);
};
export var truncateText = function (value, maxLength) {
    if (value.length <= maxLength) {
        return value;
    }
    return "".concat(value.slice(0, Math.max(0, maxLength - 1)).trimEnd(), "...");
};
